import React, { Component } from "react";
import { observer } from "mobx-react";
import { Card, Dimmer, Header } from "semantic-ui-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { computed } from "mobx";
import DisplayTitle from "~/components/element/Tour/DisplayTitle";
import Tour from "~/models/Tour";

@observer
class CustomerTourCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  @computed
  get finalThumbnailStyle() {
    const { tour } = this.props;
    const { posterThumbnailLarge, tourId, hasReadiedImmersive3dTour } = tour;

    let thumbnailStyle = null;
    let thumbnailUrl = null;
    const immersiveTourThumbnail = `${window.projectRoot}/${tourId}/images/thumbnails/768x480.jpg`;

    if (posterThumbnailLarge) {
      thumbnailUrl = posterThumbnailLarge;
    } else if (hasReadiedImmersive3dTour) {
      thumbnailUrl = immersiveTourThumbnail;
    }

    if (thumbnailUrl) {
      thumbnailStyle = {
        background: `url(${thumbnailUrl}) no-repeat center center`,
        borderRadius: "0.28571429rem",
      };
    }
    return thumbnailStyle;
  }

  handleShow = () => this.setState({ active: true });

  handleHide = () => this.setState({ active: false });

  openTourView(tourId) {
    window.open(`/public/vtour/display/${tourId}`, "_blank");
  }

  render() {
    const { tour, t } = this.props;
    const { tourId, title, mlsNumber, address, mlsService } = tour;
    const { active } = this.state;
    return (
      <Card
        className="semantic-ui"
        onClick={() => this.openTourView(tourId)}
        onMouseEnter={this.handleShow}
        onMouseLeave={this.handleHide}
      >
        <Dimmer.Dimmable dimmed={active}>
          <Dimmer active={active} style={{ backgroundColor: "rgba(0,0,0,.5)" }}>
            <Header as="h2" inverted>
              {t("customerPortal:clickTour")}
            </Header>
          </Dimmer>
          <Card.Content
            style={this.finalThumbnailStyle}
            className={this.finalThumbnailStyle ? "card-has-thumbnail-background" : "card-no-thumbnail-background"}
          >
            <Card.Description>
              {!this.finalThumbnailStyle ? (
                <div className="no-thumbnail-div">
                  {!active ? <span className="no-thumbnail-message">{t("customerPortal:noThumbnail")}</span> : null}
                </div>
              ) : null}
            </Card.Description>
          </Card.Content>
        </Dimmer.Dimmable>
        <Card.Content>
          <Card.Header>
            <DisplayTitle title={title} address={address} />
          </Card.Header>
          {title && tour.okToPubliclyDisplayAddress && (
            <Card.Description>
              {address.city}, {address.state} {address.zip}
            </Card.Description>
          )}
        </Card.Content>
        {mlsService ? (
          <>
            <Card.Content extra>{`MLS No.: ${mlsNumber} // ${mlsService.name}`}</Card.Content>
          </>
        ) : null}
      </Card>
    );
  }
}

CustomerTourCard.propTypes = {
  tour: PropTypes.instanceOf(Tour),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CustomerTourCard);
